var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatererLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.6777440309524536, 0, 0, 1.7114078998565674, -1282.5486030958382, 1847.681668157602)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M850.02-794.66c-2.59,5.06-7.3,6.99-11.22,6.99c-6.11,0-12.27-3.56-12.27-10.64v-10.73 c0-7.04,6.16-10.64,12.4-10.64c3.83,0,8.44,1.63,10.95,7.17l-6.42,2.59c-2.11-3.87-9.06-2.99-9.06,0.88v10.73 c0,3.74,7.04,4.79,8.75,0.48L850.02-794.66z",
    style: {
      fill: "rgb(212, 167, 42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M879.09-788.11h-8.44l-2.02-6.24h-8.31l-1.93,6.24h-8.44l10.86-31.14h7.17L879.09-788.11z M866.73-801.35 l-2.15-9.1h-0.22l-2.29,9.1H866.73z",
    style: {
      fill: "rgb(212, 167, 42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M892.19-811.82v23.71h-7.96v-23.71h-8.27v-7.48h24.5v7.48H892.19z",
    style: {
      fill: "rgb(212, 167, 42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M911.5-807.02h12.62v6.82H911.5v4.66h13.72v7.43h-21.68v-31.14h21.68v7.39H911.5V-807.02z",
    style: {
      fill: "rgb(212, 167, 42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M938.77-798.01h-1.41v9.9h-7.96v-31.14h12.45c6.42,0,11.39,2.95,11.57,10.25c0,5.76-2.33,9.02-6.11,10.2 l8.49,10.69h-9.81L938.77-798.01z M941.98-804.78c4.97,0,4.97-7.12,0-7.12h-4.62v7.12H941.98z",
    style: {
      fill: "rgb(212, 167, 42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M965.77-807.02h12.62v6.82h-12.62v4.66h13.72v7.43h-21.68v-31.14h21.68v7.39h-13.72V-807.02z",
    style: {
      fill: "rgb(212, 167, 42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M993.04-798.01h-1.41v9.9h-7.96v-31.14h12.45c6.42,0,11.39,2.95,11.57,10.25c0,5.76-2.33,9.02-6.11,10.2 l8.49,10.69h-9.81L993.04-798.01z M996.25-804.78c4.97,0,4.97-7.12,0-7.12h-4.62v7.12H996.25z",
    style: {
      fill: "rgb(212, 167, 42)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M794.98-913.09c-21.85-8.67-42.86-41.09-19.97-74.52c20.74-30.29,55.43-19.18,55.43-19.18 c2.29-34.46,27.46-59.86,58.88-67.91c33.77-8.65,77.14,2.1,94.79,42.33c11.3,25.74-5.3,52.67-13.48,57.35 c7.73-6.26,20.66-30.39,6.29-53.89c-11.76-19.22-35.66-31.94-58.65-31.95c-32.85-0.01-66.8,21.2-70.09,62.48 c10.44,7.75,15.05,15.66,19.29,28.7c-11.01-28.93-57.36-32.84-77.42-7.28C771.52-953.33,778.36-929.5,794.98-913.09z",
    style: {
      fill: "rgb(75, 133, 142)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1000.57-949.55c12.08-18.03,44.85-28.93,54.78,3.17c7.25,23.44-16.69,48.6-48.65,47.01l-5.26,38.66 c-1.58,11.1-11.49,15.05-23.02,13.46c-40.47-5.6-62.52-3.67-100.76,14.01c0,0,75.62-17.12,128.29,6.13l10.66-67.42 c24.48,0,50.25-27.07,42.82-58.41c-4.8-18.46-17.28-27.9-30.56-27.04C1012.2-978.89,999.72-965.5,1000.57-949.55z",
    style: {
      fill: "rgb(75, 133, 142)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018221219127972080700000015673661794610536082_",
    gradientUnits: "userSpaceOnUse",
    x1: 808.9601,
    y1: -915.9237,
    x2: 1006.6967,
    y2: -915.9237
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CD962B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#865C47"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#E7B845"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FDEB7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#E7B845"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#CD962B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9178,
    style: {
      stopColor: "#E6AE32"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F1B937"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018221219127972080700000015673661794610536082_)"
    },
    d: "M808.96-897.98 c3.42,20.53,10.64,49.86,22.14,58.97c30.19,23.92,134.73-36.51,175.59-159c-9.31,27.92-80.9,143.71-153.81,143.05 C820.08-855.25,808.96-898.36,808.96-897.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1026.06-1003.18c-4.58-11.62-9.38-22.13-9.4-22.41c0.51-7.68,0.39-11.46-0.41-16.45 c-0.56-2.87-2.15-5.75-3.8-5.67c-0.89,0.04-2.31,2.05-2.47,5.78c-0.09,2.28-0.27,5.53-0.4,8.43c-0.09,2.42-0.35,5.32-0.61,7.13 c-0.13,0.14-16.25,15.43-18.4,17.88c-0.26,0.29-0.38,0.57-0.57,0.92c-0.18,0.63-0.21,1.25-0.25,1.94 c2.34-1.36,15.91-8.45,18.33-9.74c-0.47,8.43-2.44,14.46-4.03,19.98c-1.05,3.71-1.29,4.48-1.92,5.61 c-0.31,0.64-8.91,3.83-12.42,5.24c-0.54,0.23-0.94,0.46-1.11,1.23c3.08-0.5,6.22-1.07,9.43-1.65c3.41-0.65,3.74-1.02,5.07,0.78 c1.64,2.47,3.21,4.87,4.78,7.27c0.07,0,0.37-0.78,0.28-1.19c-0.61-2.52-1.24-5.45-2.19-7.89c-0.41-1.29-0.64-1.69-0.32-2.33 c4.76-9.54,7.17-16.35,9.15-25.07c0.16-0.84,0.16-0.97,0.16-0.97c0.79,0.72,8.44,11.5,9.32,12.63c0.44,0.53,1.7,2.19,1.92,2.52 c0.18-0.49,0.42-1.33,0.52-1.96C1026.77-1001.43,1026.21-1002.85,1026.06-1003.18z",
    style: {
      fill: "rgb(212, 167, 42)"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -97.69687035228117, 566.2200401756171)"
  }, /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatererLogo);
export default __webpack_public_path__ + "static/media/caterer_logo.302b5ae2838c66e94523546d9d1b34d3.svg";
export { ForwardRef as ReactComponent };